import React from 'react'
import SectionCard from './Cards/SectionCard';
import { Consumer } from '../context';
import Logo from "../assets/logo1.png"

function Gallery() {
    return (
        <Consumer>
            {(value) => {
                const { sections } = value;
                return (
                    <div>
                        <div className="container-fluid py-3 py-lg-5" style={{ backgroundColor: "#e2566d", color: "#d3d8da" }}>
                            <div className="container text-center font-monospace fs-1">
                                <img src={Logo} alt="logo" className="pb-1" style={{width: "20%"}}/><br />
                                <span>Welcome to my ART GALLERY</span>
                            </div>
                            <div className="container text-center pt-3 pt-lg-5">
                                <div className="fs-2 shadow font-monospace">S e c t i o n s</div>
                            </div>
                        </div>
                        <div className="container-fluid py-5" style={{ backgroundColor: "#ecc9c8" }}>
                            <div className="container text-center">
                                <div className="row px-5 justify-content-center">
                                    {
                                        sections.map((sec) =>
                                        (
                                            <div className="col-12 col-md-6 col-lg-4">
                                                {<SectionCard
                                                    section={sec}
                                                />}
                                            </div>
                                        ))
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                )
            }}
        </Consumer>
    )
}

export default Gallery;
